import React from "react";

const CustomButton = ({
  title = "",
  onClick,
  wrapperClassName = "",
  textClassName = "font-size-small",
  icon,
  type = "button",
  style
}) => {
  return (
    <button
      className={`custom-button ${wrapperClassName}`}
      onClick={onClick}
      type={type}
      style={style}
    >
      {icon ? (
        <img src={icon} alt="button icon" className="w-[1.4rem] h-[1.4rem]" />
      ) : null}
      <div className={`font-family-medium ${textClassName}`}>
        {title}
      </div>
    </button>
  );
};

export default CustomButton;
